import IllegalContentLayer from '@/components/help/common/IllegalContentLayer';
import {useDialogContext} from '@soop-ui/soop-ui';

const IllegalContentLayerPC = () => {
  const {close} = useDialogContext();

  const handleClose = () => {
    close(false);
  };

  return <IllegalContentLayer handleClose={handleClose} />;
};

export default IllegalContentLayerPC;
